import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';
import { AuthService } from '../Services/auth.service';


@Injectable({
  providedIn: 'root'
})

export class CustomerInputService {

  //条件保持用
  ip_flg = false;

  constructor(
    public authService: AuthService,
    private http: MiraieService,
  ) { }

  //セッションからid取得
  user_id: number;
  getUserId() {
    this.user_id = this.authService.getUserCode();
  }

  //顧客情報初期値
  customerBase(division_code) {
    var url = "customer-base";
    let param = { division_code };

    return this.http.post(url, param);
  }

  //顧客情報詳細
  customerDetail(customer_code) {
    var url = "customer-detail";
    let param = { customer_code };

    return this.http.post(url, param);
  }

  //顧客情報削除
  customerDel(customer_code) {
    var url = "customer-delete";
    var user_id = this.user_id;
    let param = { customer_code, user_id };

    return this.http.post(url, param);
  }

  //更新履歴一覧
  customerUpdateList(customer_code) {
    var url = "customer-update-list";
    let param = { customer_code };

    return this.http.post(url, param);
  }

  //顧客情報登録
  customerInput(input, question, point, schedule, interview) {
    var url = "customer-input";
    this.getUserId();
    var user_id = this.user_id;
    let param = { input, question, point, schedule, interview, user_id };

    return this.http.post(url, param);
  }

  //注意登録・編集
  customerNotice(customer_code, notice) {
    var url = "customer-notice";
    this.getUserId();
    var user_id = this.user_id;
    let param = { notice, customer_code, user_id };

    return this.http.post(url, param);
  }
  //注意削除
  customerNoticeDel(customer_code, notice) {
    var url = "customer-notice-delete";
    this.getUserId();
    var user_id = this.user_id;
    let param = { notice, customer_code, user_id };

    return this.http.post(url, param);
  }

  //注意一覧
  customerNoticeList(customer_code) {
    var url = "customer-notice-list";
    let param = { customer_code };

    return this.http.post(url, param);
  }

  //面談履歴一覧
  customerInterviewList(customer_code) {
    var url = "customer-interview-list";
    let param = { customer_code };

    return this.http.post(url, param);
  }
  //面談履歴登録・編集
  customerInterview(interview, customer_code) {
    var url = "customer-interview";
    this.getUserId();
    var user_id = this.user_id;
    let param = { interview, customer_code, user_id };

    return this.http.post(url, param);
  }
  //面談履歴削除
  customerInterviewDel(interview, customer_code) {
    var url = "customer-interview-del";
    this.getUserId();
    var user_id = this.user_id;
    let param = { interview, customer_code, user_id };

    return this.http.post(url, param);
  }
  //面談場所一覧
  placeList(placetype) {
    var url = "place-list";
    let param = { placetype };

    return this.http.post(url, param);
  }

  //画像集登録
  customerImglistInput(img, customer_code) {
    var url = "customer-imglist-input";
    this.getUserId();
    var user_id = this.user_id;
    let param = { img, customer_code, user_id };

    return this.http.post(url, param);
  }
  //画像集削除
  customerImglistDel(img, customer_code) {
    var url = "customer-imglist-del";
    this.getUserId();
    var user_id = this.user_id;
    let param = { img, customer_code, user_id };

    return this.http.post(url, param);
  }
  //画像集一覧
  customerImglistList(customer_code) {
    var url = "customer-imglist-list";
    this.getUserId();
    var user_id = this.user_id;
    let param = { customer_code, user_id };

    return this.http.post(url, param);
  }

  //次回面談予定チェック
  customerApoCheck(customer_code) {
    var url = "customer-ap-check";

    let param = { customer_code };

    return this.http.post(url, param);
  }
  //次回面談予定・実施済あるかチェック
  customerApoDoneCheck(customer_code) {
    var url = "customer-ap-done-check";

    let param = { customer_code };

    return this.http.post(url, param);
  }
  //次回面談キャンセルチェック
  customerApoCanCheck(customer_code) {
    var url = "customer-ap-can-check";

    let param = { customer_code };

    return this.http.post(url, param);
  }
  //初回面談予約済チェック
  customerFcApoCheck(customer_code) {
    var url = "customer-fc-apo-check";

    let param = { customer_code };

    return this.http.post(url, param);
  }
  //初回面談実施済チェック
  customerFcDoneCheck(customer_code) {
    var url = "customer-fc-done-check";

    let param = { customer_code };

    return this.http.post(url, param);
  }

}
